import React from 'react';
import { UserAvatar } from 'features/users';

import { SwapFlags } from './SwapFlags';
import { AvatarGroup } from './AvatarGroup';

import DepositIcon from 'assets/deposit.svg';
import TransferIcon from 'assets/transfer.svg';
import WithdrawIcon from 'assets/withdraw.svg';

export const AvatarDisplay = ({ transaction }) => {
  const {
    userId,
    transactionType,
    groupedSwaps = [],
    groupedTransfers = [],
  } = transaction;

  const swapSender = groupedSwaps.find(
    (t) => t.transactionMethod === 'swapSender'
  );
  const swapReceiver = groupedSwaps.find(
    (t) => t.transactionMethod === 'swapReciever'
  );

  const transferSender = groupedTransfers.find(
    (t) => t.transactionType === 'Send'
  );
  const transferReceiver = groupedTransfers.find(
    (t) => t.transactionType === 'Receive'
  );

  if (groupedSwaps.length >= 2 && swapSender && swapReceiver) {
    return <SwapFlags swaps={[swapSender, swapReceiver]} />;
  }

  if (groupedTransfers.length >= 2 && transferSender && transferReceiver) {
    return (
      <AvatarGroup
        users={[transferSender, transferReceiver]}
        icon={TransferIcon}
      />
    );
  }

  if (transactionType === 'Deposit') {
    return <AvatarGroup users={[transaction]} icon={DepositIcon} />;
  }

  if (transactionType === 'Withdraw') {
    return (
      <div className="relative w-10 h-10">
        <UserAvatar userId={userId} className="w-10 h-10" />
        <div className="absolute -bottom-1 -right-1 bg-[#0E3061] p-1.5 rounded-full border-2 border-white w-6 h-6 flex items-center justify-center shadow-md">
          <img src={WithdrawIcon} alt="Withdraw Icon" className="w-3.5 h-3.5" />
        </div>
      </div>
    );
  }

  return <UserAvatar userId={userId} />;
};
